import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Scrollbars} from 'react-custom-scrollbars';
import {
    SortableContainer,
    SortableElement,
    arrayMove
} from 'react-sortable-hoc';
import Modal from '../UI/Modal';
import {Icon} from '../UI/Icon';
import {structure, single} from '../../store/actions/block';
import Collapsible from 'react-collapsible';
import {collapsibleSettings} from '../../helpers/Helpers';
import {
    GenerateRecursiveChildsWithParams,
    fixUrl,
    filterPages
} from '../../helpers/Helpers';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import _ from 'lodash';
import BtnPrimary from "../UI/BtnPrimary";
import BtnSecondary from "../UI/BtnSecondary";
import Input from "../Fields/Input";
import InputWrap from "./InputWrap";
import ReactTooltip from 'react-tooltip';
import SelectField from "./SelectField";
import CONSTANTS from "../../config/constants";
import fieldDefinitionKeys
    from "../../../../frontend/definitions/fieldDefinitionKeys";

const SortableItem = SortableElement(({value, block, content, related, workspace, language, updateItemWidth, select}) => {
    let item = {};
    let id = null;
    let title = null;
    let contentVisibilityType = null;
    let divisions = null;
    let contentType = "";

    const contentItem = _.find(content, {id: value.id});
    const blockItem = _.find(block, {id: value.id});
    const relatedItem = _.find(related, {id: value.id});
    const relatedItemContentTitle = relatedItem ? _.find(relatedItem.contentFields, {fieldDefinitionKey: 'Title'}) : null;

    if (contentItem) {
        id = contentItem.id;
        title = contentItem.title;
        contentVisibilityType = contentItem.contentVisibilityType;
        divisions = contentItem.divisions;
        contentType = contentItem.contentDefinitionKey;
    } else if (blockItem) {
        id = blockItem.id;
        title = blockItem.title;
        contentVisibilityType = blockItem.contentVisibilityType;
        divisions = blockItem.divisions;
        contentType = blockItem.contentDefinitionKey;
    } else if (relatedItem) {
        id = value.id;

        if (relatedItem.title) {
            title = relatedItem.title;
        } else if (relatedItemContentTitle) {
            title = relatedItemContentTitle.data;
        } else {
            title = value.id;
        }
    } else {
        item.Title = value.id;
        id = value.id;
    }

    const defaultValue = value.width ? {..._.find(CONSTANTS.BLOCK_WIDTH_DROPDOWN, {id: value.width})} : {...CONSTANTS.BLOCK_WIDTH_DROPDOWN[0]};

    return (
        <li className={classNamesPrefixed({'block-area-item': true})}>
            <div className={"title"}>
                <span title={contentType}>{title}</span>
                {contentVisibilityType === 'Restricted' &&
                <div
                    className={classNamesPrefixed({
                        'visibility': true
                    })}
                    data-tip={JSON.stringify(divisions)}
                >
                    <span><Icon name='ban'/></span>
                </div>
                }
            </div>
            <div className={"width"}>
                <SelectField
                    placeholder={"Width"}
                    name="width"
                    defaultValue={defaultValue}
                    omitCollapsible={true}
                    afterOnChange={(width) => {
                        updateItemWidth(value, width);
                    }}
                    items={CONSTANTS.BLOCK_WIDTH_DROPDOWN}
                />
            </div>
            <div className={"action"}>
                <a className={"edit-link"} href={fixUrl('#/workspace/1/block/' + id)} target="_blank">{''}</a>
                <span
                    className={"remove-link"}
                    onClick={(e) => {
                        e.preventDefault();
                        select(workspace, id, title, true);
                    }}
                ></span>
            </div>
        </li>
    );
});

const SortableList = SortableContainer(({items, block, content, related, workspace, language, updateItemWidth, select}) => {
    return (
        <ul className={classNamesPrefixed({
            'grey-color': true,
            'block-area-list': true
        })}>
            <li className={classNamesPrefixed({'block-area-items-title': true})}>
                <div className={"title"}>
                    <span>{"Items"}</span>
                </div>
                <div className={"width"}>
                    <span>{"Width"}</span>
                </div>
                <div className={"action"}>
                    <span>{"Action"}</span>
                </div>
            </li>
            {items.map((value, index) => (
                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    block={block}
                    content={content}
                    related={related}
                    workspace={workspace}
                    language={language}
                    value={value}
                    updateItemWidth={updateItemWidth}
                    select={select}
                />
            ))}
        </ul>
    );
});

class BlockAreaField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            search: false,
            ids: [],
            idsTemporary: [],
            blocks: [],
            blocksTemporary: [],
            data: {},
            open: {}
        };

        this.select = this.select.bind(this);
    }

    componentDidMount() {
        const {region} = this.props;
        const {value} = this.props.input;

        if (value) {
            const values = value.filter(item => item.region === region);

            this.setState({
                blocks: values,
                ids: values,
                blocksTemporary: [...values],
                idsTemporary: [...values]
            });
        }
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
    }

    showModal() {
        this.setState({
            modal: true,
            search: false
        });
    }

    hideModal() {
        this.setState({
            modal: false,
            search: false,
            blocksTemporary: [...this.state.blocks],
            idsTemporary: [...this.state.ids]
        });
    }

    save() {
        let values = this.props.input.value && this.props.input.value.length ? this.props.input.value : [];

        values = [...values.filter(item => item.region !== this.props.region), ...this.state.idsTemporary];

        this.props.input.onChange(values);

        this.setState({
            modal: false,
            search: false,
            blocks: [...this.state.idsTemporary],
            ids: [...this.state.idsTemporary]
        });
    }

    getFlatBlockList(tree, flatList) {
        let item = null;

        for (let x in tree) {
            item = tree[x];
            flatList.push(item);

            if (item.children) {
                flatList = this.getFlatBlockList(item.children, flatList);
            }
        }

        return flatList;
    }

    edit(e) {
        e.preventDefault();

        const {input, block, content, region} = this.props;

        let ids = [];
        let blocks = [];

        if (input && input.value && block && block.items) {
            let blockList = this.getFlatBlockList(block.items, []);

            input.value.filter(item => item.region === region).forEach(value => {
                const item = _.find(blockList, {id: value.id});

                if (item) {
                    ids.push(value);

                    blocks.push({
                        contentId: value.id,
                        Title: item.title
                    });
                }
            });
        }

        this.setState({
            data: {},
            open: {}
        });

        if (content && content.parentWorkspaceId) {
            this.loadStructure(content.parentWorkspaceId);
        }

        this.setState({
            modal: true,
            blocks: blocks,
            blocksTemporary: [...blocks],
            ids: ids,
            idsTemporary: [...ids]
        });
    }

    clear(e) {
        e.preventDefault();
        const {input, region} = this.props;

        input.onChange(input.value.filter(item => item.region !== region));

        this.setState({
            blocks: [],
            blocksTemporary: [],
            ids: [],
            idsTemporary: [],
            data: {},
            open: {},
            search: false
        });
    }

    toggleOpen(parentWorkspaceId) {
        const open = this.state.open[parentWorkspaceId];

        this.setState({
            open: {
                ...open,
                [parentWorkspaceId]: !open
            }
        });
    }

    search(e) {
        e.preventDefault();
        const {block} = this.props;

        const blockType = this.getChildBlockRelation();

        if (e.target.value && e.target.value !== '') {
            this.setState({
                search: e.target.value
            }, () => {
                this.props.structure(block.parentWorkspaceId, true).then(response => {
                    if (response.data) {
                        this.setState({
                            data: {
                                ...this.state.data,
                                [block.parentWorkspaceId]: GenerateRecursiveChildsWithParams(filterPages(response.data, this.state.search, blockType, true), block.parentWorkspaceId, this.select.bind(this), this.state.blocksTemporary, this.state.search, blockType)
                            },
                            open: {
                                ...this.state.open,
                                [block.parentWorkspaceId]: true
                            }
                        }, () => {
                            let target = document.getElementsByClassName('csod-awave--match');

                            if (target && target[0]) {
                                this.scrollbars.scrollTop(target[0].offsetTop);
                            }
                        });
                    }
                });
            });
        } else {
            this.setState({
                search: false
            }, () => {
                this.props.structure(block.parentWorkspaceId, true).then(response => {
                    if (response.data) {
                        this.setState({
                            data: {
                                ...this.state.data,
                                [block.parentWorkspaceId]: GenerateRecursiveChildsWithParams(filterPages(response.data, this.state.search, blockType, true), block.parentWorkspaceId, this.select.bind(this), this.state.blocksTemporary, this.state.search, blockType)
                            },
                            open: {
                                ...this.state.open,
                                [block.parentWorkspaceId]: true
                            }
                        }, () => {
                            let target = document.getElementsByClassName('csod-awave--match');

                            if (target && target[0]) {
                                this.scrollbars.scrollTop(target[0].offsetTop);
                            }
                        });
                    }
                });
            });
        }
    }

    select(parentWorkspaceId, id, title, save = false) {
        let blockIds = this.state.blocksTemporary ? this.state.blocksTemporary : [];
        let ids = this.state.idsTemporary ? this.state.idsTemporary : [];

        if (_.find(this.state.blocksTemporary, {contentId: id})) {
            _.remove(blockIds, {contentId: id});

            ids = ids.filter(value => value.id !== id);
        } else if (_.find(this.state.blocksTemporary, {id: id})) {
            _.remove(blockIds, {id: id});

            ids = ids.filter(value => value.id !== id);
        } else {
            blockIds.push({
                contentId: id,
                Title: title
            });

            ids.push({
                id: id,
                region: this.props.region
            });
        }

        this.setState({
            blocksTemporary: blockIds,
            idsTemporary: ids
        });

        const blockType = this.getChildBlockRelation();

        this.props.structure(parentWorkspaceId, true).then(response => {
            if (response.data) {
                this.setState({
                    data: {
                        ...this.state.data,
                        [parentWorkspaceId]: GenerateRecursiveChildsWithParams(filterPages(response.data, this.state.search ? this.state.search : '', blockType, true), parentWorkspaceId, this.select.bind(this), this.state.blocksTemporary, false, blockType)
                    }
                }, () => {
                    if (save) {
                        this.save();
                    }
                });
            }
        });
    }

    getChildBlockRelation() {
        const {single} = this.props.content;

        if (single && single.contentDefinitionKey && fieldDefinitionKeys[single.contentDefinitionKey] && fieldDefinitionKeys[single.contentDefinitionKey].childRelationship) {
            return fieldDefinitionKeys[single.contentDefinitionKey].childRelationship;
        }

        return this.props.blockType;
    }

    getContentDefinitionType() {
        const {definition} = this.props.content;

        return definition.contentDefinitionType
    }

    loadStructure(parentWorkspaceId) {
        const contentDefinitionType = this.getContentDefinitionType();
        const blockType = this.getChildBlockRelation();

        this.props.structure(parentWorkspaceId, true).then(response => {
            if (response.data) {
                this.setState({
                    data: {
                        ...this.state.data,
                        [parentWorkspaceId]: GenerateRecursiveChildsWithParams(filterPages(response.data, this.state.search ? this.state.search : '', blockType, true, contentDefinitionType), parentWorkspaceId, this.select.bind(this), this.state.blocksTemporary, false, blockType)
                    }
                });

                this.toggleOpen(parentWorkspaceId);
            }
        });
    }

    isOpen(parentWorkspaceId) {
        return this.state.open[parentWorkspaceId];
    }

    renderPages(parentWorkspaceId) {
        return this.state.data[parentWorkspaceId] ? this.state.data[parentWorkspaceId] : null;
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
            blocks: arrayMove(this.state.blocks, oldIndex, newIndex),
            ids: arrayMove(this.state.ids, oldIndex, newIndex),
        }, () => {
            this.props.input.onChange(this.state.ids);
        });

        document.body.style.cursor = "default";
    };

    updateItemWidth = (item, width) => {
        let blocks = [...this.state.blocks];
        let ids = [...this.state.ids];

        blocks = blocks.map(block => {
            if (block.id === item.id) {
                return {
                    ...item,
                    width: width
                };
            }

            return {
                ...block
            };
        });

        ids = ids.map(block => {
            if (block.id === item.id) {
                return {
                    ...item,
                    width: width
                };
            }

            return {
                ...block
            };
        });

        this.setState({
            blocks: blocks,
            ids: ids
        }, () => {
            this.props.input.onChange(this.props.input.value.map(block => {
                if (block.id === item.id && block.region === this.props.region) {
                    return {
                        ...item,
                        width: width
                    };
                }

                return {
                    ...block
                }
            }));
        });
    };

    onSortStart = () => {
        document.body.style.cursor = "grabbing";
    };

    getValueCount = () => {
        const {input, region} = this.props;

        const values = input.value && input.value.length ? input.value : [];

        const filteredValues = values.filter(item => item.region === region);

        return filteredValues.length;
    };

    render() {
        const {modal, ids, blocks} = this.state;
        const {label, meta: {touched, error}, workspace, routeParams, expanded} = this.props;

        //TODO fix workspeace urls, widgets dont have passed widget id via url
        let workspaceId =routeParams.workspace ? routeParams.workspace : ((workspace && workspace.items && workspace.items[0]) ? workspace.items[0].id : null);

        return (
            <Collapsible
                {...collapsibleSettings}
                trigger={label ? <label
                    className={classNamesPrefixed({"trigger__label": true})}>{label}</label> : ''}
                open={expanded}
            >
                <Modal
                    showModal={modal}
                    onClose={() => {
                        this.hideModal();
                    }}
                    title="Add block area"
                    icon="th"
                    modalFooter={
                        <div
                            className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary
                                small
                                icon={"save"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.save();
                                }}
                            >
                                Update block area
                            </BtnPrimary>
                        </div>
                    }
                >
                    <div>
                        <div>
                            <div
                                className={classNamesPrefixed({
                                    'form-item': true,
                                    'form-text': true
                                })}
                            >
                                <Input
                                    type="search"
                                    id="search"
                                    name="search"
                                    placeholder="Search by title"
                                    value={this.state.search ? this.state.search : ''}
                                    onChange={(e) => {
                                        this.search(e);
                                    }}
                                    icon={"search"}
                                />
                            </div>
                        </div>
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-text': true
                            })}
                        >
                            <InputWrap label={"Blocks"}>
                                <div
                                    className={classNamesPrefixed({'list-selector': true})}>
                                    <Scrollbars
                                        ref={(ref) => this.scrollbars = ref}
                                        autoHide={true}
                                        autoHeight={true}
                                        autoHeightMin={0}
                                        autoHeightMax={300}
                                    >
                                        <ul>
                                            {workspace.items.map((item) => {
                                                return (
                                                    <li
                                                        key={item.id}
                                                        className={classNamesPrefixed({
                                                            'open': this.isOpen(item.id),
                                                            'closed': !this.isOpen(item.id)
                                                        })}
                                                    >
                                                        <div
                                                            className={classNamesPrefixed({
                                                                'title': true
                                                            })}
                                                        >
                                                            {item.title}
                                                            <div
                                                                className={classNamesPrefixed({
                                                                    'icon': true
                                                                })}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.loadStructure(item.id);
                                                                }}>
                                                                {this.isOpen(item.id) ? (
                                                                    <Icon
                                                                        name="chevron-up"/>
                                                                ) : (
                                                                    <Icon
                                                                        name="chevron-down"/>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <ul>
                                                            {this.renderPages(item.id)}
                                                        </ul>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </Scrollbars>
                                </div>
                            </InputWrap>

                        </div>
                    </div>
                </Modal>
                {this.getValueCount() === 0 ? (
                    <div className={classNamesPrefixed({'form-actions': true})}>
                        <BtnPrimary
                            onClick={(e) => {
                                e.preventDefault();

                                this.showModal();
                            }}
                        >
                            Add block
                        </BtnPrimary>
                    </div>
                ) : (
                    <Fragment>
                        <SortableList
                            items={ids}
                            blocks={blocks}
                            content={this.props.content.flat}
                            block={this.props.block.flat}
                            related={this.props.content && this.props.content.single ? this.props.content.single.relatedContents : []}
                            language={routeParams.language}
                            workspace={workspaceId}
                            onSortEnd={this.onSortEnd}
                            onSortStart={this.onSortStart}
                            updateItemWidth={this.updateItemWidth}
                            select={this.select}
                            lockAxis={"y"}
                            helperClass={"active"}
                            distance={5}
                        />
                        <div
                            className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary small
                                        onClick={this.edit.bind(this)}>Edit</BtnPrimary>
                            <BtnSecondary small
                                          onClick={this.clear.bind(this)}>Remove</BtnSecondary>
                        </div>
                    </Fragment>
                )}
                {touched && error && <div
                    className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
            </Collapsible>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.language,
        workspace: state.workspace,
        block: state.block,
        content: state.content
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        single: (key, languageCode) => dispatch(single(key, languageCode)),
        structure: (parentWorkspaceId, skipStore) => dispatch(structure(parentWorkspaceId, skipStore))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BlockAreaField)



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/BlockAreaField.js